import React, { Component } from "react";
import Cookies from "universal-cookie";
import moment from "moment";
import { Buffer } from "buffer";

import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";

import { stockOtodisService } from "../../services/otodisApi/StockOtodisService";

import { Button, Col, DatePicker, Form, Input, Row, Modal } from "antd";

import { SaveOutlined, UndoOutlined } from "@ant-design/icons";
import CurrencyInput from "react-currency-input-field";

import { PurchaseStockStates } from "./types/PurchaseStockTypes";
import WarehouseSelect from "../../components/warehouse/WarehouseSelect";
import SupplierSelect from "../../components/supplier/SupplierSelect";
import VehicleModelSelect from "../../components/selects/vehicle-copan/VehicleModelSelect";

import SelectConfigArray from "../../components/selects/SelectConfigArray";
import { allowedOrganization, vehicleConditionList } from "../../config/data/generalConfig";
import VehicleVariantSelect from "../../components/selects/vehicle-copan/VehicleVariantSelect";
import VehicleVariantColorSelect from "../../components/selects/vehicle-copan/VehicleVariantColorSelect";

export interface PurchaseStockProps {}

class PurchaseStock extends Component<PurchaseStockProps & any, PurchaseStockStates> {
  private readonly initState!: PurchaseStockStates;
  private uDealer = JSON.parse(Buffer.from(new Cookies().get("_d"), "base64").toString());
  private token = new Cookies().get("_t");

  constructor(props: (PurchaseStockProps & any) | any) {
    super(props);

    const finalDealerCode = props.match.params.dealerCode.replace(/-/g, "#");
    const picked = this.uDealer.find((o: { DealerCode: any }) => o.DealerCode === finalDealerCode);
    const companyCode = picked?.DealerCompany ?? "AMARTA";
    // console.log(companyCode);

    const pickedOrganization: any = allowedOrganization.find((o) => o.companyId === companyCode.toUpperCase()) ?? {};
    // console.log(pickedOrganization);

    this.initState = {
      processing: false,
      submitting: false,

      dealerCode: finalDealerCode,
      companyCode: companyCode,
      dataOrg: pickedOrganization,

      supplierCode: null,
      warehouseCode: null,
      invoiceDate: moment().clone().format("YYYY-MM-DD"),
      invoiceNumber: "",
      deliveryDate: moment().clone().format("YYYY-MM-DD"),
      deliveryNumber: "",
      vehicleModelCode: null,
      vehicleVariantCode: null,
      vehicleColorCode: "",
      vehicleColorName: "",
      vehicleEngineNumber: "",
      vehicleChassisNumber: "",
      vehicleLicensePlate: "",
      vehicleCondition: null,
      vehicleYear: moment().clone().format("YYYY"),
      taxPercentage: 11,
      vehiclePurchasePrice: 0,
      vehiclePurchaseDiscount: 0,
      vehicleBasicPurchasePrice: 0,
      vehiclePurchaseVat: 0,
      vehicleFixedPurchasePrice: 0,
      vehicleSalesPrice: 0,

      //   supplierCode: "SUP#CRY#10009701-DEFAULT",
      //   warehouseCode: "WRH#CRY#10009701-DEFAULT",
      //   invoiceDate: moment().clone().format("YYYY-MM-DD"),
      //   invoiceNumber: "TES ADD STOCK RORA - Nomor Invoice",
      //   deliveryDate: moment().clone().format("YYYY-MM-DD"),
      //   deliveryNumber: "TES ADD STOCK RORA - Nomor Surat Jalan",
      //   vehicleModelCode: "omoda 5",
      //   vehicleVariantCode: "T7150EXXFR7998",
      //   vehicleColorCode: "T7150EGBWFR7998",
      //   vehicleColorName: "",
      //   vehicleEngineNumber: "TES ADD STOCK RORA - Nomor Mesin",
      //   vehicleChassisNumber: "TES ADD STOCK RORA - Nomor Rangka ",
      //   vehicleLicensePlate: "TES ADD STOCK RORA - Nomor Polisi",
      //   vehicleCondition: "NEW",
      //   vehicleYear: moment().clone().format("YYYY"),
      //   taxPercentage: 11,
      //   vehiclePurchasePrice: 9999999,
      //   vehiclePurchaseDiscount: 0,
      //   vehicleBasicPurchasePrice: 9999999,
      //   vehiclePurchaseVat: 1100000,
      //   vehicleFixedPurchasePrice: 11099999,
      //   vehicleSalesPrice: 1000000,
    };
    this.state = { ...this.initState };
  }

  onDealerChange = async (data: any) => {
    await this.promisedSetState({
      dealerCode: data.value,
      warehouseCode: null,
      supplierCode: null,
    });
  };

  onWarehouseChange = async (data: any) => {
    await this.promisedSetState({
      warehouseCode: data.value,
    });
  };

  onSupplierChange = (data: any) => {
    this.setState({
      supplierCode: data.value,
    });
  };

  onVehicleModelChange = (data: any) => {
    this.setState({
      vehicleModelCode: data.value,
      vehicleVariantCode: "",
    });
  };

  onVehicleVariantChange = (data: any) => {
    this.setState({
      vehicleVariantCode: data.value,
    });
  };

  onVehicleColorChange = (data: any) => {
    this.setState({
      vehicleColorCode: data.value,
      vehicleColorName: data.attr,
    });
  };

  onStringFieldChange = <
    T extends keyof Pick<
      any,
      | "companyCode"
      | "deliveryDate"
      | "deliveryNumber"
      | "invoiceDate"
      | "invoiceNumber"
      | "vehicleCondition"
      | "vehicleChassisNumber"
      | "vehicleEngineNumber"
      | "vehicleLicensePlate"
      | "vehicleYear"
      | "taxPercentage"
      | "vehiclePurchasePrice"
      | "vehiclePurchaseDiscount"
      | "vehicleSalesPrice"
    >
  >(
    target: T,
    value: any
  ) => {
    const currentState: any = { ...this.state };

    switch (target) {
      case "companyCode":
        currentState.companyCode = value;
        break;
      case "deliveryDate":
        currentState.deliveryDate = value;
        break;
      case "deliveryNumber":
        currentState.deliveryNumber = value;
        break;
      case "invoiceDate":
        currentState.invoiceDate = value;
        break;
      case "invoiceNumber":
        currentState.invoiceNumber = value;
        break;
      case "vehicleCondition":
        currentState.vehicleCondition = value;
        break;

      case "vehicleEngineNumber":
        currentState.vehicleEngineNumber = value;
        break;
      case "vehicleChassisNumber":
        currentState.vehicleChassisNumber = value;
        break;
      case "vehicleLicensePlate":
        currentState.vehicleLicensePlate = value;
        break;
      case "vehicleYear":
        currentState.vehicleYear = value;
        break;

      case "taxPercentage":
        currentState.taxPercentage = value;
        break;
      case "vehiclePurchasePrice":
        currentState.vehiclePurchasePrice = value;
        break;
      case "vehiclePurchaseDiscount":
        currentState.vehiclePurchaseDiscount = value;
        break;

      case "vehicleSalesPrice":
        currentState.vehicleSalesPrice = value;
        break;
    }

    let dppBeli = 0;
    let ppnBeli = 0;
    let hppBeli = 0;

    if (target === "taxPercentage" || target === "vehiclePurchasePrice" || target === "vehiclePurchaseDiscount") {
      dppBeli = currentState.vehiclePurchasePrice - currentState.vehiclePurchaseDiscount;
      currentState.vehicleBasicPurchasePrice = Number(dppBeli.toFixed(0));

      if (currentState.taxPercentage > 0) {
        ppnBeli = Math.ceil(dppBeli * (Number(currentState.taxPercentage) / 100));
      }

      hppBeli = dppBeli + ppnBeli;
      currentState.vehiclePurchaseVat = Number(ppnBeli.toFixed(0));
      currentState.vehicleFixedPurchasePrice = Number(hppBeli.toFixed(0));
    }

    this.setState({
      ...currentState,
    });
  };

  onReset = async () => {
    await this.promisedSetState({
      ...this.initState,
    });
  };

  onAddStock = async () => {
    const currentState: any = { ...this.state };

    if (currentState.vehicleCondition === "SECOND" && currentState.vehicleEngineNumber === "") {
      currentState.vehicleEngineNumber = currentState.vehicleLicensePlate;
    }

    if (!currentState.dealerCode) {
      Modal.error({ title: "Error", content: "Invalid Dealer" });
      return;
    }
    if (!currentState.companyCode) {
      Modal.error({ title: "Error", content: "Invalid Company Code" });
      return;
    }
    if (!currentState.supplierCode) {
      Modal.error({ title: "Error", content: "Supplier harus diisi" });
      return;
    }
    if (!currentState.warehouseCode) {
      Modal.error({ title: "Error", content: "Gudang harus diisi" });
      return;
    }
    if (!currentState.invoiceDate) {
      Modal.error({ title: "Error", content: "Tanggal Invoice harus diisi" });
      return;
    }
    if (!currentState.invoiceNumber) {
      Modal.error({ title: "Error", content: "Nomor Invoice harus diisi" });
      return;
    }
    if (!currentState.deliveryDate) {
      Modal.error({ title: "Error", content: "Tanggal Surat Jalan harus diisi" });
      return;
    }
    if (!currentState.deliveryNumber) {
      Modal.error({ title: "Error", content: "Nomor Surat Jalan harus diisi" });
      return;
    }
    if (!currentState.vehicleVariantCode) {
      Modal.error({ title: "Error", content: "Variant Kendaraan harus diisi" });
      return;
    }
    if (!currentState.vehicleColorCode) {
      Modal.error({ title: "Error", content: "Warna Kendaraan harus diisi" });
      return;
    }
    if (!currentState.vehicleColorName) {
      Modal.error({ title: "Error", content: "Invalid Warna Kendaraan" });
      return;
    }
    if (!currentState.vehicleEngineNumber) {
      Modal.error({ title: "Error", content: "Nomor Mesin harus diisi" });
      return;
    }
    if (!currentState.vehicleChassisNumber) {
      Modal.error({ title: "Error", content: "Nomor Rangka harus diisi" });
      return;
    }
    if (!currentState.vehicleCondition) {
      Modal.error({ title: "Error", content: "Kondisi Kendaraan harus diisi" });
      return;
    }
    if (!currentState.vehicleLicensePlate && currentState.vehicleCondition === "SECOND") {
      Modal.error({ title: "Error", content: "Normor Polisi harus diisi" });
      return;
    }
    if (!currentState.vehicleYear) {
      Modal.error({ title: "Error", content: "Tahun Kendaraan harus diisi" });
      return;
    }
    if (!currentState.taxPercentage || currentState.taxPercentage < 0) {
      Modal.error({ title: "Error", content: "Persentase Pajak Beli harus diisi" });
      return;
    } else if (currentState.taxPercentage > 30) {
      Modal.error({ title: "Error", content: "Persentase Pajak tidak valid" });
      return;
    }
    if (!currentState.vehiclePurchasePrice || currentState.vehiclePurchasePrice < 0) {
      Modal.error({ title: "Error", content: "Harga Beli harus diisi" });
      return;
    }
    if (!currentState.vehicleBasicPurchasePrice || currentState.vehicleBasicPurchasePrice < 0) {
      Modal.error({ title: "Error", content: "Invalid DPP Beli" });
      return;
    }
    if (!currentState.vehiclePurchaseVat || currentState.vehiclePurchaseVat < 0) {
      Modal.error({ title: "Error", content: "Invalid PPN Beli" });
      return;
    }
    if (!currentState.vehicleFixedPurchasePrice || currentState.vehicleFixedPurchasePrice < 0) {
      Modal.error({ title: "Error", content: "Invalid HPP Beli" });
      return;
    }
    if (!currentState.vehicleSalesPrice || currentState.vehicleSalesPrice < 0) {
      Modal.error({ title: "Error", content: "Estimasi Harga Jual harus diisi" });
      return;
    }

    this.setState({ submitting: true });

    const input = {
      dealer_code: currentState.dealerCode,
      company_code: currentState.companyCode,
      supplier_code: currentState.supplierCode,
      warehouse_code: currentState.warehouseCode,
      invoice_date: currentState.invoiceDate,
      invoice_number: currentState.invoiceNumber,
      delivery_date: currentState.deliveryDate,
      delivery_number: currentState.deliveryNumber,
      vehicle_variant_code: currentState.vehicleVariantCode,
      vehicle_color_code: currentState.vehicleColorCode,
      vehicle_color_name: currentState.vehicleColorName,
      vehicle_engine_number: currentState.vehicleEngineNumber,
      vehicle_chassis_number: currentState.vehicleChassisNumber,
      vehicle_license_plate: currentState.vehicleLicensePlate,
      vehicle_condition: currentState.vehicleCondition,
      vehicle_year: currentState.vehicleYear,
      tax_percentage: currentState.taxPercentage,
      vehicle_purchase_price: Number(currentState.vehiclePurchasePrice),
      vehicle_purchase_discount: Number(currentState.vehiclePurchaseDiscount),
      vehicle_basic_purchase_price: Number(currentState.vehicleBasicPurchasePrice),
      vehicle_purchase_vat: Number(currentState.vehiclePurchaseVat),
      vehicle_fixed_purchase_price: Number(currentState.vehicleFixedPurchasePrice),
      vehicle_sales_price: Number(currentState.vehicleSalesPrice),
    };

    try {
      await stockOtodisService.setToken(this.token);
      await stockOtodisService.addSingleStock(input).then((dataInsertStock) => {
        Modal.success({
          title: "Proses Sukses",
          content: "Stock berhasil di tambahkan",
        });
        setTimeout(function () {
          window.location.reload();
        }, 2000);
      });
    } catch (e: any) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda :" + e.message,
      });
      await this.promisedSetState({
        submitting: false,
      });
    }
  };

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout
          onChangeDealer={this.onDealerChange}
          breadcrumbPath={`Stock`}
          breadcrumbMenu={`Pembelian Stock`}
          defaultSelectedKeys={["m-purchase-stock"]}
          defaultOpenKeys={["sm-stock", "sm-sm-purchase"]}
        >
          <Form layout={"vertical"}>
            <Row>
              <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Supplier <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <SupplierSelect onSupplierChangeProps={this.onSupplierChange} dealerCode={this.state.dealerCode} value={this.state.supplierCode} />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Gudang <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <WarehouseSelect onWarehouseChangeProps={this.onWarehouseChange} dealerCode={this.state.dealerCode} value={this.state.warehouseCode} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Tanggal Surat Jalan <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <DatePicker
                        value={moment(this.state.deliveryDate, "YYYY-MM-DD")}
                        format={"YYYY-MM-DD"}
                        style={{ width: "100%" }}
                        onChange={(date, dateString) => this.onStringFieldChange("deliveryDate", dateString)}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Nomor Surat Jalan <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <Input type="text" value={this.state.deliveryNumber} placeholder="Nomor Surat Jalan" onChange={(event) => this.onStringFieldChange("deliveryNumber", event.target.value)} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Tanggal Invoice <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <DatePicker
                        value={moment(this.state.invoiceDate, "YYYY-MM-DD")}
                        format={"YYYY-MM-DD"}
                        style={{ width: "100%" }}
                        onChange={(date, dateString) => this.onStringFieldChange("invoiceDate", dateString)}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Nomor Invoice <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <Input type="text" value={this.state.invoiceNumber} placeholder="Nomor Invoice" onChange={(event) => this.onStringFieldChange("invoiceNumber", event.target.value)} />
                    </Form.Item>
                  </Col>
                </Row>
                {/* <Divider orientation="left" plain></Divider> */}
                <br />{" "}
              </Col>
            </Row>

            <Row>
              <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Kondisi Kendaraan <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <SelectConfigArray value={this.state.vehicleCondition} onChange={(value: string) => this.onStringFieldChange("vehicleCondition", value)} dataOption={vehicleConditionList} />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Model Kendaraan <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <VehicleModelSelect
                        onVehicleModelChangeProps={this.onVehicleModelChange}
                        value={this.state.vehicleModelCode}
                        companyCode={this.state.dataOrg.copanCode}
                        areaCode={this.state.dataOrg.copanAreaCode}
                        brandCode={this.state.dataOrg.copanDefaultBrand}
                        time={Math.floor(+new Date() / 1000)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Variant Kendaraan <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <VehicleVariantSelect
                        onVehicleVariantChangeProps={this.onVehicleVariantChange}
                        value={this.state.vehicleVariantCode}
                        companyCode={this.state.dataOrg.copanCode}
                        areaCode={this.state.dataOrg.copanAreaCode}
                        cityGroup={this.state.dataOrg.copanAreaCode}
                        brandCode={this.state.dataOrg.copanDefaultBrand}
                        modelCode={this.state.vehicleModelCode}
                        time={Math.floor(+new Date() / 1000)}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Warna Kendaraan <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <VehicleVariantColorSelect
                        companyCode={this.state.dataOrg.copanCode}
                        areaCode={this.state.dataOrg.copanAreaCode}
                        brandCode={this.state.dataOrg.copanDefaultBrand}
                        modelCode={this.state.vehicleModelCode}
                        variantCode={this.state.vehicleVariantCode}
                        value={this.state.vehicleColorCode}
                        onVehicleVariantColorChangeProps={this.onVehicleColorChange}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Nomor Mesin <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <Input type="text" value={this.state.vehicleEngineNumber} placeholder="Nomor Mesin" onChange={(event) => this.onStringFieldChange("vehicleEngineNumber", event.target.value)} />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Nomor Rangka <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <Input
                        type="text"
                        value={this.state.vehicleChassisNumber}
                        placeholder="Nomor Rangka"
                        onChange={(event) => this.onStringFieldChange("vehicleChassisNumber", event.target.value)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>Nomor Polisi </i>
                      <Input type="text" value={this.state.vehicleLicensePlate} placeholder="Nomor Polisi" onChange={(event) => this.onStringFieldChange("vehicleLicensePlate", event.target.value)} />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Tahun Kendaraaan <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <DatePicker
                        value={moment(this.state.vehicleYear, "YYYY")}
                        format={"YYYY"}
                        style={{ width: "100%" }}
                        onChange={(date, dateString) => this.onStringFieldChange("vehicleYear", dateString)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Persentase Pajak Beli <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <Input type="number" value={this.state.taxPercentage} placeholder="Persentase Pajak" onChange={(event) => this.onStringFieldChange("taxPercentage", event.target.value)} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Harga Beli <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <CurrencyInput
                        className={"ant-input"}
                        allowDecimals={false}
                        decimalsLimit={2}
                        groupSeparator={"."}
                        decimalSeparator={","}
                        prefix={"Rp. "}
                        value={this.state.vehiclePurchasePrice}
                        onValueChange={(value) => this.onStringFieldChange("vehiclePurchasePrice", value ? parseFloat(value) : 0)}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>Diskon Beli</i>
                      <CurrencyInput
                        className={"ant-input"}
                        allowDecimals={false}
                        decimalsLimit={2}
                        groupSeparator={"."}
                        decimalSeparator={","}
                        prefix={"Rp. "}
                        value={this.state.vehiclePurchaseDiscount}
                        onValueChange={(value) => this.onStringFieldChange("vehiclePurchaseDiscount", value ? parseFloat(value) : 0)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>DPP Beli</i>
                      <CurrencyInput
                        className={"ant-input"}
                        allowDecimals={false}
                        decimalsLimit={2}
                        groupSeparator={"."}
                        decimalSeparator={","}
                        prefix={"Rp. "}
                        value={this.state.vehicleBasicPurchasePrice}
                        disabled={true}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>PPN Beli </i>
                      <CurrencyInput
                        className={"ant-input"}
                        allowDecimals={false}
                        decimalsLimit={2}
                        groupSeparator={"."}
                        decimalSeparator={","}
                        prefix={"Rp. "}
                        value={this.state.vehiclePurchaseVat}
                        disabled={true}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>HPP Beli</i>
                      <CurrencyInput
                        className={"ant-input"}
                        allowDecimals={false}
                        decimalsLimit={2}
                        groupSeparator={"."}
                        decimalSeparator={","}
                        prefix={"Rp. "}
                        value={this.state.vehicleFixedPurchasePrice}
                        disabled={true}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Estimasi Harga Jual <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <CurrencyInput
                        className={"ant-input"}
                        allowDecimals={false}
                        decimalsLimit={2}
                        groupSeparator={"."}
                        decimalSeparator={","}
                        prefix={"Rp. "}
                        value={this.state.vehicleSalesPrice}
                        onValueChange={(value) => this.onStringFieldChange("vehicleSalesPrice", value ? parseFloat(value) : 0)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row>
              <Col xl={{ span: 6 }} lg={{ span: 8 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                    <Button type={"primary"} icon={<SaveOutlined />} loading={this.state.submitting} onClick={this.onAddStock} style={{ width: "100%" }}>
                      Simpan Data
                    </Button>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                    <Button type={"primary"} danger icon={<UndoOutlined />} onClick={this.onReset} loading={this.state.submitting} style={{ width: "100%" }}>
                      Reset Form
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(PurchaseStock), 2);
